$(function () {
    "use strict";

    /* ===== Preloader ===== */

    $(function () {
        $(".preloader").fadeOut();
    });

    /* ===== Megamenu ===== */

    jQuery(document).on('click', '.mega-dropdown', function (e) {
        e.stopPropagation()
    });

    /* ===== This is the active menu js ===== */

    $(function () {
        var url = window.location;
        var element = $('ul.sidebar-menu a').filter(function () {
            return this.href === url || url.href.indexOf(this.href) === 0;
        }).addClass('active').parent().parent().parent().parent().addClass('selected').parent();
        if (element.is('li')) {
            element.addClass('active');
        }
    });

    // ==============================================================
    // This is for the top header part and sidebar part
    // ==============================================================

    var set = function () {
        var width = (window.innerWidth > 0) ? window.innerWidth : this.screen.width;
        var topOffset = 55;
        if (width < 2000) {
            $("body").addClass("mini-sidebar");
            $('.mini-nav li.selected').addClass('cnt-none');
            $("#togglebtn").hide();
        } else {
            $("body").removeClass("mini-sidebar");
            $('.mini-nav > li.selected').removeClass('cnt-none');
            $("#togglebtn").show();
        }
        if (width < 1549) {
            //$("body").addClass('rmv-right-panel');
            $('.right-side-toggle i').addClass('ti-arrow-left');
        } else {
            //$("body").removeClass('rmv-right-panel');
            $('.right-side-toggle i').removeClass('ti-arrow-left');
        }
        var height = ((window.innerHeight > 0) ? window.innerHeight : this.screen.height) - 1;
        height = height - topOffset;
        if (height < 1) height = 1;
        if (height > topOffset) {
            $(".page-wrapper").css("min-height", (height) + "px");
        }
    };
    $(window).ready(set);
    $(window).on("resize", set);

    /* ===== This is for click on Sidebar open close button ===== */

    $(".mini-nav > li:has(.sidebarmenu), #togglebtn").on('click', function (e) {
        if ($("body").hasClass("rmv-sidebarmenu")) {
            $("body").trigger("resize");
            $("#togglebtn").hide();
        } else {
            $("body").trigger("resize");
            $("#togglebtn").show();
        }
        if (typeof $(e.target).attr('href') === 'undefined' && $(e.target).parents('.btn-add-contact').length == 0) {
            return false;
        }
    });

    $('body').click(function (e) {
        let target = $(e.target);
        if (!target.hasClass('sidebarmenu') && target.parents('.sidebarmenu').length == 0 && !(target.is('li') && !target.hasClass('first-element') && target.parents('.mini-nav').length > 0)) {
            $("#togglebtn").hide();
            $('.mini-nav > li.selected').removeClass('selected');
            $('.mini-nav > li.selected').removeClass('cnt-none');
        }
        if (!target.hasClass('right-sidebar') && target.parents('.right-sidebar').length == 0 && !target.hasClass('right-side-toggle') && target.parents('.right-side-toggle').length == 0) {
            $("#togglebtn").hide();
            $('.mini-nav > li.selected').removeClass('selected');
            $('.mini-nav > li.selected').removeClass('cnt-none');
            $('body').addClass('rmv-right-panel');
        }
    });

    $(".mini-nav > li, #togglebtn").on('click', function () {
        if ($("body").hasClass("mini-sidebar")) {
            $('.mini-nav > li.selected').removeClass('cnt-none');
            $("#togglebtn").show();
        }
    });

    /* ===== Sidemenu toggle ===== */

    $(".mini-nav").css("overflow", "hidden").parent().css("overflow", "visible");

    $('#togglebtn').on("click", function () {
        $('#togglebtn').hide();
        $('.mini-nav > li.selected').addClass('cnt-none');
    });

    $('.mini-nav > li').on("click", function () {
        $('#togglebtn').show();
        $('.mini-nav > li.selected').removeClass('cnt-none');
        $("body").removeClass('rmv-sidebarmenu');
    });

    $('.mini-nav > li').on('click', function () {
        $('.mini-nav > li.selected').removeClass('selected');
        $(this).addClass('selected');
    });

    $.sidemenu = function (menu) {
        var animationSpeed = 300;
        $(menu).on('click', 'li a', function (e) {
            if ($(this).next().is('.sub-menu') && $(this).next().is(':visible')) {
                $(this).next().slideUp(animationSpeed, function () {
                    $(this).next().removeClass('menu-open');
                });
                $(this).next().parent("li").removeClass("active");
            } else if (($(this).next().is('.sub-menu')) && (!$(this).next().is(':visible'))) {
                var parent = $(this).parents('ul').first();
                parent.find('ul:visible').slideUp(animationSpeed).removeClass('menu-open');
                $(this).next().slideDown(animationSpeed, function () {
                    $(this).next().addClass('menu-open');
                    parent.find('li.active').removeClass('active');
                    $(this).parent("li").addClass('active');
                });
            }
        });
    }
    $.sidemenu($('.sidebar-menu'));

    /* ===== Add or removed class from body ===== */

    $('#togglebtn').on('click', function () {
        $("body").removeClass('mini-sidebar');
        $("body").addClass('mini-sidebar');
    });

    /* ===== Open-Close-right sidebar ===== */

    $(".right-side-toggle .nav-link, .right-side-toggle .ti-close").on('click', function () {
        $("body").toggleClass('rmv-right-panel');
        // $('.right-side-toggle i').toggleClass('ti-arrow-left');
    });

    // ==============================================================
    // This is for the floating labels
    // ==============================================================

    $('.floating-labels .form-control').on('focus blur', function (e) {
        $(this).parents('.form-group').toggleClass('focused', (e.type === 'focus' || this.value.length > 0));
    }).trigger('blur');

    // ==============================================================
    // tooltip
    // ==============================================================

    $(function () {
        $('[data-toggle="tooltip"]').tooltip()
    });

    // ==============================================================
    // Popover
    // ==============================================================

    $(function () {
        $('[data-toggle="popover"]').popover()
    })

    // ==============================================================
    // Perfact scrollbar
    // ==============================================================

    $('.right-side-panel, .message-center, .right-sidebar, .tab-content').perfectScrollbar();



    // ==============================================================
    // Resize all elements
    // ==============================================================

    $("body").trigger("resize");

    // ==============================================================
    // To do list
    // ==============================================================

    $(".list-task li label").on('click', function () {
        $(this).toggleClass("task-done");
    });

    // ==============================================================
    // Collapsable cards
    // ==============================================================

    $('a[data-action="collapse"]').on('click', function (e) {
        e.preventDefault();
        $(this).closest('.card').find('[data-action="collapse"] i').toggleClass('ti-minus ti-plus');
        $(this).closest('.card').children('.card-body').collapse('toggle');
    });

    // Toggle fullscreen
    $('a[data-action="expand"]').on('click', function (e) {
        e.preventDefault();
        $(this).closest('.card').find('[data-action="expand"] i').toggleClass('mdi-arrow-expand mdi-arrow-compress');
        $(this).closest('.card').toggleClass('card-fullscreen');
    });

    // Close Card
    $('a[data-action="close"]').on('click', function () {
        $(this).closest('.card').removeClass().slideUp('fast');
    });

    // ==============================================================
    // Color variation
    // ==============================================================

    var mySkins = [
        "skin-default",
        "skin-green",
        "skin-red",
        "skin-blue",
        "skin-purple",
        "skin-megna",
        "skin-default-dark",
        "skin-green-dark",
        "skin-red-dark",
        "skin-blue-dark",
        "skin-purple-dark",
        "skin-megna-dark"
    ]
    /**
     * Get a prestored setting
     *
     * @param String name Name of of the setting
     * @returns String The value of the setting | null
     */
    function get(name) {
        if (typeof (Storage) !== 'undefined') {
            return localStorage.getItem(name)
        } else {
            window.alert('Please use a modern browser to properly view this template!')
        }
    }
    /**
     * Store a new settings in the browser
     *
     * @param String name Name of the setting
     * @param String val Value of the setting
     * @returns void
     */
    function store(name, val) {
        if (typeof (Storage) !== 'undefined') {
            localStorage.setItem(name, val)
        } else {
            window.alert('Please use a modern browser to properly view this template!')
        }
    }

    /**
     * Replaces the old skin with the new skin
     * @param String cls the new skin class
     * @returns Boolean false to prevent link's default action
     */
    function changeSkin(cls) {
        $.each(mySkins, function (i) {
            $('body').removeClass(mySkins[i])
        })
        $('body').addClass(cls)
        store('skin', cls)
        return false
    }

    function setup() {
        var tmp = get('skin')
        if (tmp && $.inArray(tmp, mySkins)) changeSkin(tmp)
        // Add the change skin listener
        $('[data-skin]').on('click', function (e) {
            if ($(this).hasClass('knob')) return
            e.preventDefault()
            changeSkin($(this).data('skin'))
        })
    }
    setup()
    $("#themecolors").on("click", "a", function () {
        $("#themecolors li a").removeClass("working"),
            $(this).addClass("working")
    })





    // DATA TABLE

    $(function () {
        $('#myTable').DataTable();
        $(function () {
            var table = $('#example').DataTable({
                "columnDefs": [{
                    "visible": false,
                    "targets": 2
                }],
                "order": [
                    [2, 'asc']
                ],
                "displayLength": 25,
                "drawCallback": function (settings) {
                    var api = this.api();
                    var rows = api.rows({
                        page: 'current'
                    }).nodes();
                    var last = null;
                    api.column(2, {
                        page: 'current'
                    }).data().each(function (group, i) {
                        if (last !== group) {
                            $(rows).eq(i).before('<tr class="group"><td colspan="5">' + group + '</td></tr>');
                            last = group;
                        }
                    });
                }
            });
            // Order by the grouping
            $('#example tbody').on('click', 'tr.group', function () {
                var currentOrder = table.order()[0];
                if (currentOrder[0] === 2 && currentOrder[1] === 'asc') {
                    table.order([2, 'desc']).draw();
                } else {
                    table.order([2, 'asc']).draw();
                }
            });
        });
    });

    $('#example23').DataTable({
        dom: 'Bfrtip',
        buttons: [
            'copy', 'csv', 'excel', 'pdf', 'print'
        ]
    });
    $('.buttons-copy, .buttons-csv, .buttons-print, .buttons-pdf, .buttons-excel').addClass('btn btn-primary mr-1');

    $(function () {
        $('.filter-searching').click(function () {
            $('.filter-searching-content').toggle() // AFFICHE ET CACHE A CHAQUE CLIQUE SUR LE BOUTTON
        });

        $(".filter-searching-content .filter-searching-content").removeClass('sorting');

    });

    $(function () {
        $('.panel-heading a').click(function () {
            $('#create-category').toggle() // AFFICHE ET CACHE A CHAQUE CLIQUE SUR LE BOUTTON
        });
    });

    $(function () {
        $('.panel-heading-actions a').click(function () {
            $('.category-options').toggle() // AFFICHE ET CACHE A CHAQUE CLIQUE SUR LE BOUTTON
        });


    });

    $(function () {
        $('.panel-action-button a').click(function () {
            $('.panel-wrapper').toggle() // AFFICHE ET CACHE A CHAQUE CLIQUE SUR LE BOUTTON
        });


    });


});

// BTN SWITCH

$(function () {
    // Switchery
    var elems = Array.prototype.slice.call(document.querySelectorAll('.js-switch'));
    // $('.js-switch').each(function () {
    //     new Switchery($(this)[0], $(this).data());
    // });
    // For select 2
    // $(".select2").select2();
    $('.selectpicker').selectpicker();
    //Bootstrap-TouchSpin
    $(".vertical-spin").TouchSpin({
        verticalbuttons: true
    });
    var vspinTrue = $(".vertical-spin").TouchSpin({
        verticalbuttons: true
    });
    if (vspinTrue) {
        $('.vertical-spin').prev('.bootstrap-touchspin-prefix').remove();
    }
    $("input[name='tch1']").TouchSpin({
        min: 0,
        max: 100,
        step: 0.1,
        decimals: 2,
        boostat: 5,
        maxboostedstep: 10,
        postfix: '%'
    });
    $("input[name='tch2']").TouchSpin({
        min: -1000000000,
        max: 1000000000,
        stepinterval: 50,
        maxboostedstep: 10000000,
        prefix: '$'
    });
    $("input[name='tch3']").TouchSpin();
    $("input[name='tch3_22']").TouchSpin({
        initval: 40
    });
    $("input[name='tch5']").TouchSpin({
        prefix: "pre",
        postfix: "post"
    });
    // For multiselect
    $('#pre-selected-options').multiSelect();
    $('#optgroup').multiSelect({
        selectableOptgroup: true
    });
    $('#public-methods').multiSelect();
    // $('#select-all').click(function () {
    //     $('#public-methods').multiSelect('select_all');
    //     return false;
    // });
    $('#deselect-all').click(function () {
        $('#public-methods').multiSelect('deselect_all');
        return false;
    });
    $('#refresh').on('click', function () {
        $('#public-methods').multiSelect('refresh');
        return false;
    });
    $('#add-option').on('click', function () {
        $('#public-methods').multiSelect('addOption', {
            value: 42,
            text: 'test 42',
            index: 0
        });
        return false;
    });
    $(".ajax").select2({
        ajax: {
            url: "https://api.github.com/search/repositories",
            dataType: 'json',
            delay: 250,
            data: function (params) {
                return {
                    q: params.term, // search term
                    page: params.page
                };
            },
            processResults: function (data, params) {
                // parse the results into the format expected by Select2
                // since we are using custom formatting functions we do not need to
                // alter the remote JSON data, except to indicate that infinite
                // scrolling can be used
                params.page = params.page || 1;
                return {
                    results: data.items,
                    pagination: {
                        more: (params.page * 30) < data.total_count
                    }
                };
            },
            cache: true
        },
        escapeMarkup: function (markup) {
            return markup;
        }, // let our custom formatter work
        minimumInputLength: 1,
        //templateResult: formatRepo, // omitted for brevity, see the source of this page
        //templateSelection: formatRepoSelection // omitted for brevity, see the source of this page
    });
});


// MODAL DIALOG OPENING

$('.task').click(function () {
    $('.modal-com-plan').modal('show')
})


$(function () {
    $('#open').click(function () {
        $('.modal-plan-com').modal('show')
    })
    $('.closemodal span').click(function () {
        $('.modal-plan-com').modal('hide')
    })
})


// POPUP GED OPENING

$('.card-img-top').click(function () {
    $('.details-doc-popup').modal('show')
})


$(function () {
    $('#open').click(function () {
        $('.details-doc-popup').modal('show')
    })
    $('.rpanel-title a').click(function () {
        $('.details-doc-popup').modal('hide')
    })
})
